import type { ValueFormatterParams } from "ag-grid-community";

import { Flex, Text, tokens } from "~/ui";

export const CommentCellRenderer = (params: ValueFormatterParams<string>) => {
  const label = (params?.value as string) || "";
  if (!label) {
    return null;
  }

  return (
    <Flex
      direction="column"
      gap="xs"
      style={{
        borderRadius: tokens.radius.xs,
        width: "100%",
        minWidth: "100%",
      }}
    >
      <Text
        size="sm"
        lineClamp={2}
        style={{
          wordBreak: "break-word",
          width: "100%",
          lineHeight: "1.4",
        }}
      >
        {label.length > 100 ? `${label.slice(0, 100)}...` : label}
      </Text>
    </Flex>
  );
};
